import * as validate from './validate.js';

export const singer = [validate];
